import React, {Fragment, useState} from 'react';
import "./SelectionBox.scss";
import DatePicker from "react-multi-date-picker";
import {getTodayDate} from "../AutoCFunction";
import VideoProgressBar from "../Progress/VideoProgressBar";
import CustomeDatePicker from "../../CustomeDatePicker";
import Button from "../../UI/Button";
import numeric from "../../../utils/NumericFunction";

const SelectionBox = (props) => {

  let {data, setData, onSubmit, onPlay, onStop, progressBarValue, setProgressBarValue} = props;


  const radioChange = (e) => {
    setData({requestType: e.target.value, loader: true})

  }


  console.log(data)
  return (
    <div className={'autoC'}>

      <div className={'d-flex  w-100 justify-content-start'}>
        <div className={'bg__white__radius d-flex my-2'}>
          <div className={'position-relative  ms-3 '}>
            <div className={'absoluteText'}>
              وسیله نقلیه
            </div>
            <select
              onChange={(e) => setData({carType: e.target.value})}
              className={'carType'}
              value={data.carType}
            >
              <option value="all">همه</option>
              <option value="bus">اتوبوس</option>
              <option value="taxi">تاکسی</option>

            </select>

          </div>

          <div className={'position-relative'}>
            <div className={'absoluteText'}>
              جستجو
            </div>
            <div className={'absolute__search__icon cursor__pointer'}
                 onClick={() => setData({plateSubmit: !data.plateSubmit})}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.58342 18.125C4.87508 18.125 1.04175 14.2917 1.04175 9.58332C1.04175 4.87499 4.87508 1.04166 9.58342 1.04166C14.2917 1.04166 18.1251 4.87499 18.1251 9.58332C18.1251 14.2917 14.2917 18.125 9.58342 18.125ZM9.58342 2.29166C5.55841 2.29166 2.29175 5.56666 2.29175 9.58332C2.29175 13.6 5.55841 16.875 9.58342 16.875C13.6084 16.875 16.8751 13.6 16.8751 9.58332C16.8751 5.56666 13.6084 2.29166 9.58342 2.29166Z"
                  fill="#B9B9B9"/>
                <path
                  d="M18.3338 18.9583C18.1754 18.9583 18.0171 18.8999 17.8921 18.7749L16.2254 17.1083C15.9838 16.8666 15.9838 16.4666 16.2254 16.2249C16.4671 15.9833 16.8671 15.9833 17.1088 16.2249L18.7754 17.8916C19.0171 18.1333 19.0171 18.5333 18.7754 18.7749C18.6504 18.8999 18.4921 18.9583 18.3338 18.9583Z"
                  fill="#B9B9B9"/>
              </svg>
            </div>
            <input
              type={'text'}
              className={'carType'}
              value={numeric.e2p(data.plate)}
              onChange={(e) => setData({plate: e.target.value})}
              placeholder={'پلاک مورد نظر را وارد کنید'}
            />


          </div>
        </div>
        <div className={'bg__white__radius my-2 d-flex align-items-center'}>
          <div className={'d-flex'} onChange={radioChange.bind(this)}>
            <div>
              <input value={'currentLocations'}
                     name={"status"}
                     id={'onlineRadioAutoC'}
                     checked={data.requestType === 'currentLocations'}
                     type="radio"/>
              <label htmlFor="onlineRadioAutoC">آنلاین</label>
            </div>
            <div className={'me-5'}>
              <input value={'locationsArchive'} name={"status"}
                     id={'archiveRadioAutoC'} type="radio"
                     checked={data.requestType === 'locationsArchive'}

              />
              <label htmlFor="archiveRadioAutoC">بایگانی</label>
            </div>
          </div>
          {data.requestType === 'locationsArchive' && <>
            <div className={'mx-3 portrait__line'}></div>
            <div className={'position-relative  mx-2'}>
              <div className={'absoluteText'}>
                تاریخ
              </div>
              <div className={'datePicker '}>
                <CustomeDatePicker onChange={(newDate) => setData({date: numeric.p2e(newDate)})}

                                   placeholder={'تاریخ'}
                                   value={data.date !== '' ? data.date : getTodayDate()}
                />
              </div>

            </div>
            <div className={'position-relative  mx-1 '}>
              <div className={'absoluteText'}>
                ساعت
              </div>
              <div className={''}>
                <input
                  value={data.startTime}
                  onChange={(e) => setData({startTime: e.target.value})}
                  className={'carType'}
                  style={{width: 150}}
                  type={'time'} step={"1"}/>
              </div>

            </div>
            <div className={'position-relative  mx-2 '}>
              <div className={'absoluteText'}>
                سرعت
              </div>
              <select
                onChange={(e) => setData({speed: e.target.value})}
                className={'carType'}
                style={{width: 150}}
                value={data.speed}
              >
                <option value="">انتخاب کنید</option>
                <option value="1">1x</option>
                <option value="10">10x</option>
                <option value="20">20x</option>
                <option value="40">40x</option>
                <option value="80">80x</option>
                <option value="1000">1000X</option>
              </select>

            </div>
          </>}


        </div>


      </div>
      {
        data.requestType === 'locationsArchive' &&
        <>
          <div className={'bg__white__radius my-2 d-flex align-items-center w-100'}>
            <VideoProgressBar
              progressBarValue={progressBarValue}
              setProgressBarValue={setProgressBarValue}
            />
          </div>
        </>
        // <div
        //   className={'bg__white__radius w-100'}
        // >
        //   <input type={'range'} className={'w-100'} dir={'ltr'}/>
        // </div>

      }
      <div className={'text-center my-2'}>
        <Button
          onClick={onSubmit}
          className={'px-2 mx-2'}
        >
          ثبت
        </Button>
        <Button
          onClick={onPlay}
          className={'px-2 mx-2'}

        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" id="play">
            <path
              d="M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18c.62-.39.62-1.29 0-1.69L9.54 5.98C8.87 5.55 8 6.03 8 6.82z"></path>
          </svg>

        </Button>
        <Button
          onClick={onStop}
          className={'px-2 mx-2 position-relative'}


        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" id="play">

          </svg>
          <div
            style={{
              position: 'absolute',
              top: 3,
              left: 3,

            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" id="play">
              <path fill="none" d="M0 0h48v48H0z"></path>
              <path d="M12 12h24v24H12z"></path>
            </svg>


          </div>
        </Button>

      </div>
    </div>

  );
};

export default SelectionBox;
